import { FormControlLabel, Switch } from '@mui/material';
import styled from 'styled-components';

const PageContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

interface DueDateTextProps {
  $overdue: boolean;
}

const DueDateText = styled.span<DueDateTextProps>`
  color: ${({ theme, $overdue }) => ($overdue ? theme.palette.error.main : 'inherit')};
  font-weight: ${({ $overdue }) => ($overdue ? 'bold' : 'inherit')};
`;

const ExamAutoDropForm = styled(FormControlLabel)`
  white-space: nowrap;
`;

const ExamAutoDropSwitch = styled(Switch)`
  margin-left: ${({ theme }) => theme.spacing(2)};
`;

export { PageContainer, DueDateText, ExamAutoDropSwitch, ExamAutoDropForm };
